export const REDIRECT_EXTERNAL = 'OD/REDIRECT_EXTERNAL'

export interface RedirectExternalAction {
  readonly type: typeof REDIRECT_EXTERNAL;
  readonly payload: { url: string };
}


export const raiseRedirectExternal = (url: string): RedirectExternalAction => ({
  type: REDIRECT_EXTERNAL,
  payload: { url },
})






